import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import line_item from "./line.item.module";
import visit from "./visit.module";
import leave from "./leave.module";
import request from "./request.module";
import preventive from "./preventive.module";
import job from "./job.module";
import invoice from "./invoice.module";
import common from "./common.module";
import customer from "./customer.module";
import custom_field from "./custom.fields.module";
import filter from "./filter.module";
import dashboard from "./dashboard.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    request,
    common,
    customer,
    preventive,
    visit,
    leave,
    line_item,
    custom_field,
    job,
    filter,
    dashboard,
    invoice,
  },
});
